import Routes from "./routes";
import { getKey } from "./uitls";
import { log } from "@/utils/console";
import router from "@/router/router";

export default (eventBus: any, keyName: string) => {
  const updateSessionStatck = (routes: any) => {
    log("【Router Stack】：", routes, "rgb(238, 158, 46)");
  };

  const isChildRouteJump = (toRoute: any, fromRoute: any) => {
    if (toRoute && fromRoute) {
      const toRoutePathArr = toRoute.path.split("/");
      const fromRoutePathArr = fromRoute.path.split("/");
      if (
        toRoutePathArr.length === fromRoutePathArr.length &&
        toRoutePathArr.length > 2 &&
        fromRoutePathArr.length > 2 &&
        toRoutePathArr[length - 2] === fromRoutePathArr[length - 2]
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const forward = (toRoute: any, fromRoute: any) => {
    Routes.unshift(toRoute);
    eventBus.$emit("forward", toRoute, fromRoute);
    updateSessionStatck(Routes);
  };
  const back = (toIndex: number, toRoute: any, fromRoute: any) => {
    Routes.splice(0, toIndex);
    eventBus.$emit("back", toRoute, fromRoute);
    updateSessionStatck(Routes);
  };
  const replace = (toRoute: any, fromRoute: any, isChildRoute: boolean) => {
    Routes.splice(0, 1, toRoute);
    eventBus.$emit("replace", toRoute, fromRoute, isChildRoute);
    updateSessionStatck(Routes);
  };
  const refresh = (toRoute: any, fromRoute: any) => {
    Routes[0] = toRoute;
    eventBus.$emit("refresh", toRoute, fromRoute);
    updateSessionStatck(Routes);
  };
  const reset = () => {
    Routes.splice(0, Routes.length);
    eventBus.$emit("reset");
    updateSessionStatck([]);
  };

  const record = (toRoute: any, fromRoute: any, replaceFlag: boolean) => {
    const fullPath = getKey(toRoute, keyName);
    const toIndex = Routes.findIndex((route: any) => {
      return route.fullPath === fullPath;
    });
    let isChildRoute: boolean = false;
    if (isChildRouteJump(toRoute, fromRoute)) {
      isChildRoute = true;
    }
    if (replaceFlag || isChildRoute) {
      replace(toRoute, fromRoute, isChildRoute);
    } else {
      if (toIndex === -1) {
        forward(toRoute, fromRoute);
      } else if (toIndex === 0) {
        refresh(toRoute, fromRoute);
      } else {
        back(toIndex, toRoute, fromRoute);
      }
    }
  };
  /**
   * 在某些手机上，由于webview写入的历史记录有问题，会导致vipplan payment这些页面无法返回，增加判断，解决路由返回的问题
   * @param num  返回页面的数量，默认是-1，为负数
   */

  const goBack = (num: number = -1) => {
    const length = window.history.length;
    const backNum = Math.abs(num);
    if (length > backNum) {
      router.go(num);
    } else {
      console.info("window.history", window.history);
      const routerName = Routes.splice(backNum)[0];
      router.replace(routerName);
    }
  };

  return {
    record,
    reset,
    goBack
  };
};
